import { render, staticRenderFns } from "./layActiveArchive.vue?vue&type=template&id=5ad5ec59"
import script from "./layActiveArchive.vue?vue&type=script&lang=js"
export * from "./layActiveArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports